import { useQuery } from 'react-query';
import { OptionType } from '../../../../CommonComponents/OPL/Select/BaseSelect/types';
import { CMAType } from '../../../../AdviserSettings/Page/CustomModelAssumptions/types';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { queryKeys } from './queryKeys';

export interface RetirementExpenseOption {
  value: number;
  label: string;
}

export interface AssumptionsDTO {
  assumeCurrentTaxRateProvisionsExpire: boolean | null;
  capitalGainsRatio: number | null;
  incomeGrowthRate: number | null;
  inflationRate: number | null;
  lifeExpectancy: number | null;
  loanBalanceInterestRate: number | null;
  monteCarloSimulations: number | null;
  portfolioReturnsMethodology: number | null;
  potentialRevenueRate: number | null;
  socialSecurityInflationRate: number | null;
  tuitionInflationRate: number | null;
  turnoverRatio: number | null;
  riskToleranceWorkflow: number | null;
  enableAutoGeneratedWhatIfs: boolean;
  capitalMarketAssumptions: CMAType;
  enhancedReportExperience: boolean;
  excessCashFlowToSave: number | null;
  monteCarloSuccessRange: number | null;
  retirementExpenses: number | null;
  retirementExpensesOptions: RetirementExpenseOption[];
  retirementExpensesAmount: number | null;
}

export interface AgreementDTO {
  id: string;
  name: string;
  file: string;
  isActive: boolean;
  lastUpdated: string;
  fileSize: number;
}

export interface FirmSettingsDTO {
  agreements: AgreementDTO[];
  allowAdvisersOverrideAgreements: boolean;
  allowAdvisersCustomTermsAndConditions: boolean;
  allowAdvisersOverrideFirmLogo: boolean;
  assumptionsEditableByAdviser: boolean;
  clientLandingPage: number | null;
  clientLandingPageOptions: OptionType<number>[];
  customDisclosures: string;
  customDisclosuresEditableByAdviser: boolean;
  customFirmUrl: string;
  customTermsAndConditions: string;
  disableAdviserSuggestions: boolean;
  firmAssumptions: AssumptionsDTO;
  firmLogoFilename: string | null;
  supportTeamEmails: string[] | null;
  allowAssetBucketing: boolean;
  allowClientToCustomizeAssetAssignmentAcrossBuckets: boolean;
  displayAssetBucketing: boolean;
  showAgreements: boolean;
  is3dRiskToleranceWorkflowEnabled: boolean;
  allowAdviserOverrideAddManualAccount: boolean;
  allowAddManualAccount: boolean;
  allowBeFi20: boolean;
  hasAcceptedBeFi20Terms: boolean;
  allowAdvisersToDelegateClientLevelAssetBucketingCustomization: boolean;
  allowAdvisersToCustomizeAssetBucketingLayout: boolean;
  allowPulseCheck: boolean;
  allowMobileAppPushNotifications: boolean;
  defaultDocumentUploadMobilePushNotifications: boolean;
  allowPersonalFinancesCsvExport: boolean;
  hasDocumentVault: boolean;
  allowAccountNickname: boolean;
}

const fetchFirmSettings = (): Promise<FirmSettingsDTO> => {
  return authFetch('/Adviser/Settings/Firm');
};

export const useFirmSettingsQuery = () => {
  return useQuery(
    queryKeys.firmSettings(),

    () => fetchFirmSettings(),

    {
      cacheTime: 0,
    },
  );
};
